import { InputNumber, Popconfirm, Spin, Table, message, notification } from 'antd';
import React, {useEffect} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { rejectedApiMessage } from '../../utilities/CommonHelper';
import { fetchAvailablePOsToMap, unMapPOcall, updatePOMapping } from '../../store/reducers/orderDashboardSlice';
import Link from 'antd/es/typography/Link';
import CustomButton from '../../components/Buttons/Button';
import FloatLabel from '../../components/FloatLabel/floatLabel';

const MappedPOContainer = (props :any) => {

    const dispatch = useDispatch();
    const orderDashboardData = useSelector((state: any) => state.orderDashboard);
    const [selectedPO, setSelectedPO] = React.useState<any>({});
    const [mappedPOs, setMappedPOs] = React.useState<any[]>([]);
    const [workorderMapDetails, setWorkorderMapDetails] = React.useState<any>({});
    const [isMapSectionEnabled, setIsMapSectionEnabled] = React.useState<boolean>(false);
    const [mapValue, setMapValue] = React.useState<string>('');


    useEffect(() => {
      if(props.isModalOpen && props.activeTab==='2'){
        fetchMappedPOList();
        }

    }, [props.selectedWorkOrder,props.isModalOpen,props.activeTab])


    const fetchMappedPOList=()=>{
        dispatch(fetchAvailablePOsToMap({workOrderId:props.selectedWorkOrder.id}))
        .then(
            (response: any) => {
              if (response.type !== 'orderDashboard/fetchAvailablePOsToMap/fulfilled') {
                rejectedApiMessage(response.payload);
              }
              else{
                  setMappedPOs(response.payload.mappedPos);
                  setWorkorderMapDetails(response.payload);
              }
            }
          );
    }
    const handleUnMapPO =(record :any)=>{
        console.log("record",record);
        setIsMapSectionEnabled(false);
        setMapValue('');
        setSelectedPO(record);
        dispatch(unMapPOcall({workOrderId:props.selectedWorkOrder.id, poNumber:record.poNumber}))
        .then(
            (response: any) => {
              if (response.type !== 'orderDashboard/unMapPOcall/fulfilled') {
                rejectedApiMessage(response.payload);
              }
              else{
                  notification.success({
                    message: 'Success',
                    description: 'PO Unmapped Successfully',
                  });
                  fetchMappedPOList();

              }
            }
          );
        // dispatch(props.onPOUnmappingSuccess(record));
        
    }
    const handleEditPOMapping =(record :any)=>{
        setSelectedPO(record);
        setIsMapSectionEnabled(true);
        setMapValue(record.mappedPoValue);
    }
    const handleSubmit=()=>{
      console.log("map value",mapValue);
      if(Number(mapValue)<=0){
        message.warning("Map PO value should be greater than 0");
        return;
      }
      const payload: any={};
      payload["workOrderId"] = props.selectedWorkOrder.id;
      payload["poNumber"] = selectedPO.poNumber;
      payload["mappedPoValue"]= mapValue;
      payload["id"]=selectedPO.id;

      dispatch(updatePOMapping({payloads:payload}))
      .then((response: any) => {
          if (response.type==='orderDashboard/updatePOMapping/fulfilled') {
            console.log('revokeByAdmin response', response);
            notification.success({
              message: 'Success',
              description: 'PO Mapped successfully',
            });
            // props.onPOMappingSuccess();
            fetchMappedPOList();
            setIsMapSectionEnabled(false);
            setSelectedPO({});
            setMapValue('');
          } else {
            rejectedApiMessage(response.payload);
          }
        });

  }
  return (
    <div>
      <Spin spinning={orderDashboardData.loading} >
        <div>
          <p>
            <b>WorkOrder Id:</b> {props.selectedWorkOrder.id}
          </p>
          <p>
            <b>Total Contract Value:</b> {workorderMapDetails.totalContractValue}
          </p>
          <p>
            <b>Available Contract Value:</b> {workorderMapDetails.avlContractValue || 0}
          </p>
          <p>
            <b>Mapped Contract Value:</b> {workorderMapDetails.mappedContractValue || 0}
          </p>
        </div>
        <Table
          dataSource={mappedPOs}
          scroll={{ x: 'max-content', y: 300}}
          className='table-style'
          columns={[
            {
              title: 'PO Number',
              dataIndex: 'poNumber',
              key: 'poNumber',
              fixed: 'left',
              width: 150,
            },
            {
              title: 'Client Entity',
              dataIndex: 'clientEntity',
              key: 'clientEntity',
              width: 180,
            },
            {
              title: 'Indegene Entity',
              dataIndex: 'indegeneEntity',
              key: 'indegeneEntity',
              width: 180,
            },
            {
              title: 'Currency',
              dataIndex: 'currency',
              key: 'currency',
              width: 150,
            },
            {
              title: 'PO Start Date',
              dataIndex: 'poStartDate',
              key: 'poStartDate',
              width: 150,
            },
            {
              title: 'PO Expiry Date',
              dataIndex: 'poEndDate',
              key: 'poEndDate',
              width: 150,
            },
            {
                title: 'Mapped PO Value',
                dataIndex: 'mappedPoValue',
                key: 'mappedPoValue',
                width: 150,
                // render: (text: any, record: any) => (<span>{(record.totalPOValue-record.mappedPoValue).toFixed(2)}</span>)
            },
            {
                title: 'Action',
                dataIndex: 'map',
                key: 'map',
                fixed: 'right',
                width: 100,
                render: (text: any, record: any) => (
                  <>
                <Popconfirm title="Are you sure you want to unmap this PO?" onConfirm={()=>handleUnMapPO(record)} okText="Yes" cancelText="No">
                    <Link className='maplink' onClick={()=>null}>
                      Unmap
                  </Link>
                </Popconfirm>
                <br/>
                <Link className='maplink' onClick={()=>handleEditPOMapping(record)}>
                      Edit
                  </Link>
                  </>
                )
            }

          ]}
          // loading={userDashboard?.loading}
        />
        {
            isMapSectionEnabled && <div>
                <div className="row" style={{ display: 'flex', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', width: 'calc(100% - 20px)', backgroundColor: "#f5f8fa", padding: '10px 0px 10px 0px', color: '#000', margin:'10px' }}><div style={{ font: 'bold 14px / 20px "Nunito Sans"' }}>Edit Mapped PO Section #{selectedPO.poNumber}</div>
                    &nbsp;
                    </div>
                    
                </div>
                <div className="row" style={{ display: 'flex', flexWrap: 'wrap',justifyContent:'space-between' }}>
                    <div className='col-lg-4 col-md-4 col-sm-12'>
                        <FloatLabel label="Map PO Value *" value={mapValue}>
                        {/* <Input
                            type='number'
                            min={0}
                            step={1}
                            onKeyDown={handleKeyDown}
                            onWheel={(e) => {
                            const target = e.target as HTMLInputElement;
                            target.blur()
                            }}
                            value={mapValue}
                            id="totalcontractvalue"
                            size='middle'
                            style={{ width: '100%', height: 58, marginRight: '10px',paddingTop:'15px' }}
                            required={true}
                            disabled={false}
                            onChange={(e) =>setMapValue(Number(e.target.value))}
                        /> */}
                        <InputNumber 
                        value={mapValue} 
                        // min={0} 
                        size='middle'
                        style={{ width: '100%', height: 58, marginRight: '10px',paddingTop:'15px' }}
                        onChange={(e:any) =>setMapValue(e)} 
                        // max={selectedPO.totalPOValue-Number(selectedPO.mappedValue)}
                         />
                        </FloatLabel>
                    </div>
                </div>
                <div className="row" style={{ display: 'flex', flexWrap: 'wrap',margin:'30px 10px 10px 10px ',justifyContent:'flex-end' }}>
                    <CustomButton label="Cancel" type="cancel" onClick={()=>{setIsMapSectionEnabled(false); 
                            setSelectedPO({});
                            setWorkorderMapDetails({});
                            setMapValue('');}} />
                    <CustomButton label="Submit" type="submit" disabled={!mapValue} onClick={()=>handleSubmit()} />
                </div>
                </div>
        }
      </Spin>
    </div>
  )
}

export default MappedPOContainer